import {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import './star.scss';

const Star = ({page, isFilled}) => {

	const [showFilledStar, setShowFilledStar] = useState(isFilled);
	const [animateStar, setAnimateStar] = useState(true);

	useEffect(() => {
		if (!isFilled && showFilledStar) setShowFilledStar(false);

		if (!isFilled || showFilledStar) return;
		
		const timeout = setTimeout(() => {
			setShowFilledStar(true);
			setAnimateStar(true);
		}, 400);
		
		return () => {
			/* Component will unmount */
			if (timeout) clearTimeout(timeout);
		};
	}, [isFilled, showFilledStar, page]);
	
	return (
		<div className={'Star'}>
			{animateStar && 
				<div className='Star-glow' />
			}
			<div className={'Star-image ' 
				+ page 
				+ (showFilledStar ? ' filled' : '') 
				+ (animateStar ? ' animate' : '')}
			/>
		</div>
	);
};

Star.propTypes = {
	page: PropTypes.string.isRequired,
	isFilled: PropTypes.bool
};

export default Star;
